import globalConfig from './../../Data/globalConfig.json';
import myWorkConfig from 'Data/myworkConfig.json';

export enum Env {
  Dev = 'dev',
  Int = 'int',
  Ppe = 'ppe',
  Prod = 'prod',
}

export const isProd = (): boolean => {
  return (
    isBLProd() ||
    isPLProd() ||
    window.location.hostname === 'news.agent.safeco.com' ||
    window.location.hostname === 'agent.public.libertymutual.com'
  );
}

export const getEnv = (): Env => {
  const hostname = window.location.hostname?.toLowerCase();
  if (hostname?.includes('.dev.')) return Env.Dev;
  else if (hostname?.includes('int-')) return Env.Int;
  else if (hostname?.includes('ppe-')) return Env.Ppe;
  else return Env.Prod;
};

export const isPL = (): boolean => {
  //below condition checking the url path can be removed once we decommission agent news
  const hostname = window.location.hostname?.toLowerCase();
  if (hostname?.startsWith('news.') || hostname?.includes('public.')) {
    return window?.location?.pathname?.toLowerCase().includes('/pl/');
  } else {
    const isSafeco =
      hostname === 'safeco.com' || hostname?.endsWith('.safeco.com');
    const isPreviewPL = hostname?.includes('preview-pl');
    const isPreviewNow = hostname?.includes('preview-now');
    const isPersonalAgent = hostname?.includes('personal-agent');
    return isSafeco || isPreviewPL || isPreviewNow || isPersonalAgent;
  }
};

export const isBL = (): boolean => {
  //below condition checking the url path can be removed once we decommission agent news
  const hostname = window.location.hostname?.toLowerCase();
  if (hostname?.startsWith('news.') || hostname?.includes('public.')) {
    return window?.location?.pathname?.toLowerCase().includes('/bl/');
  } else {    
    const isPreviewSC = hostname?.includes('preview-sc');
    const isCommercialAgent = hostname?.includes('commercial-agent');
    return (!isPL()) || isPreviewSC || isCommercialAgent;
  }
};

export const isPublic = (): boolean => { 
  const hostname = window.location.hostname?.toLowerCase();
  return hostname?.includes('public.');
};

export const isBLProd = (): boolean => {
  let domain = window.origin;
  return domain === globalConfig.BL.domain.legacy.prod || domain === globalConfig.BL.domain.onebrand.prod;
};

export const isPLProd = (): boolean => {
  let domain = window.origin;
  return domain === globalConfig.PL.domain.legacy.prod || domain === globalConfig.PL.domain.onebrand.prod;
};

export const getPLDomain = (): string => {
  if (isProd()) {
    return isOneBrand() 
      ? globalConfig.PL.domain.onebrand.prod 
      : globalConfig.PL.domain.legacy.prod;
  } else {
    return isOneBrand() 
      ? globalConfig.PL.domain.onebrand.nonProd 
      : globalConfig.PL.domain.legacy.nonProd;
  }
};

export const getBLDomain = (): string => {
  if (isProd()) {
    return isOneBrand() 
      ? globalConfig.BL.domain.onebrand.prod 
      : globalConfig.BL.domain.legacy.prod;
  } else {
    return isOneBrand() 
      ? globalConfig.BL.domain.onebrand.nonProd 
      : globalConfig.BL.domain.legacy.nonProd;
  }
};

export const getPLOneBrandDomain = (): string => {
  return isProd() 
    ? globalConfig.PL.domain.onebrand.prod 
    : globalConfig.PL.domain.onebrand.nonProd;
};

export const getBLOneBrandDomain = (): string => {
  return isProd() 
    ? globalConfig.BL.domain.onebrand.prod 
    : globalConfig.BL.domain.onebrand.nonProd;
};


export const isOneBrand = (): boolean => {
  const hostname = window.location.hostname?.toLowerCase();
  const isPersonalAgent = hostname?.includes('personal-agent');
  const isCommercialAgent = hostname?.includes('commercial-agent');
  return isPersonalAgent || isCommercialAgent;
}

export const getPLForgotPassword = (): string => {
  //isProd() ? globalConfig.PL.forgotPassword.onebrand.prod : globalConfig.PL.forgotPassword.onebrand.nonProd;
  try{
    if(isProd()){
      if(isOneBrand()){
        return globalConfig.PL.forgotPassword.onebrand.prod;
      } else {
        return globalConfig.PL.forgotPassword.legacy.prod;
      }
    } else{
      if(isOneBrand()){
        return globalConfig.PL.forgotPassword.onebrand.nonProd;
      } else{
        return globalConfig.PL.forgotPassword.legacy.nonProd;
      }
    }
  } catch(error){
    return '';
  }
}

export const getBLForgotPassword = (): string => {
  try{
    if(isBLProd()){
        return globalConfig.BL.forgotPassword.prod;
    } else{
        return globalConfig.BL.forgotPassword.nonProd;
    }
  } catch(error){
    return '';
  }
}

export const getBLAgentPortalLink = (): string => {
  if (isBLProd()) return globalConfig.BL.wasPortal.agent.prod;
  else return globalConfig.BL.wasPortal.agent.nonProd;
};

export const getBLPortalURL = (isAgent: boolean): string => {
  if (isProd()) return isAgent ? globalConfig.BL.wasPortal.agent.prod : globalConfig.BL.wasPortal.employee.prod;
  else return isAgent ? globalConfig.BL.wasPortal.agent.nonProd : globalConfig.BL.wasPortal.employee.nonProd;
};

export const getBLPolicyDocumentLink = (isAgent: boolean): string => {
  if (isBLProd())
    return `${
      isAgent ? globalConfig.BL.wasPortal.agent.prod : globalConfig.BL.wasPortal.employee.prod
    }/portal/apodNavLinks.do`;
  else
    return `${
      isAgent ? globalConfig.BL.wasPortal.agent.nonProd : globalConfig.BL.wasPortal.employee.nonProd
    }/portal/apodNavLinks.do`;
};

export const getBLQuoteLink = (isAgent: boolean): string => {
  const userObject = isAgent ? globalConfig.BL.quote.agent : globalConfig.BL.quote.employee;
  return isProd() ? userObject?.prod : userObject?.nonProd;
};

export const getCoveoSearchPageUrl = (): string => {
  return globalConfig.Coveo.searchPage;
};

export const getArrangeFinancialsUrl = (): string => {
  return globalConfig.BL.arrangeFinancials;
};

export const getRecentActivitiesLink = (): string => {
  try{
    if (isPL()) {
      if (isPLProd()) {
        if(isOneBrand()){
          return globalConfig.PL.recentActivitiesLink.onebrand.prod;
        } else {
          return globalConfig.PL.recentActivitiesLink.legacy.prod;
        }
      } else {
        if(isOneBrand()){
          return globalConfig.PL.recentActivitiesLink.onebrand.nonProd;
        } else {
          return globalConfig.PL.recentActivitiesLink.legacy.nonProd;
        }
      }
    } else {
      return '/RecentActivities';
    }
  } catch(error){
    return '';
  }
};

export const getPremiumAuditLink = (): string | null => {
  return isBLProd() ? globalConfig.BL.premiumAuditLink.prod : !isPL() ? globalConfig.BL.premiumAuditLink.nonProd : null;
};

export const getAppetiteLink = (): string | null => {
  return isBLProd() ? globalConfig.BL.appetite.prod : !isPL() ? globalConfig.BL.appetite.nonProd : null;
};

export const getEcliqLink = (): string | null => {
  return isBLProd() ? globalConfig.BL.ecliq.prod : !isPL() ? globalConfig.BL.ecliq.nonProd : null;
};

export const getUserIdSuffix = (isBL: boolean): string => {
  if (isBL) {
    if (isBLProd()) {
      return globalConfig.BL.userIdSuffix.prod;
    } else {
      return globalConfig.BL.userIdSuffix.nonProd;
    }
  } else {
    if (isPLProd()) {
      return globalConfig.PL.userIdSuffix.prod;
    } else {
      return globalConfig.PL.userIdSuffix.nonProd;
    }
  }
};

export const getLogoutLink = (isBL: boolean): string => {
  try {
    if (isBL) {
      return isBLProd() ? globalConfig.BL.logoutLink.prod : globalConfig.BL.logoutLink.nonProd;
    }

    if (isOneBrand()) {
      const env = getEnv();
      if (env) return `${globalConfig.Public.domain.legacy[env]}${globalConfig.PL.logoutPage}`;
    }
    
    return `${globalConfig.PL.logoutPage}`;
    
  } catch (error) {
    return '';
  }
};

export const getPingPLLogoutIFrameURL = () =>
  isProd() ? globalConfig.PL.pingLogoutIFrameURL.prod : globalConfig.PL.pingLogoutIFrameURL.nonProd;

export const getSettingsLink = (isBL: boolean): string => {
  if (isBL) {
    if (isBLProd()) {
      return globalConfig.BL.settingsLink.prod;
    } else {
      return globalConfig.BL.settingsLink.nonProd;
    }
  } else {
    return globalConfig.PL.settingsLink;
  }
};
export const getManageIdPasswordLink = (isBL: boolean): string => {
  if (isBL) {
    if (isBLProd()) {
      return globalConfig.BL.manageIdPasswordLink.prod;
    } else {
      return globalConfig.BL.manageIdPasswordLink.nonProd;
    }
  } else {
    return '';
  }
};

export const getSmartworksMRCSSOURL = (isBL: boolean): string => {
  if (isBL) {
    if (isBLProd()) {
      return globalConfig.BL.smartworksMRCSSOURL.prod;
    } else {
      return globalConfig.BL.smartworksMRCSSOURL.nonProd;
    }
  } else {
    return '';
  }
};

//Claim File Browser - legacy system used for CVO claims
export const getCFBLink = (claimNumber: string) => {
  try{
    if(isPLProd()){
      if(isOneBrand()){
        return `${globalConfig.PL.cfb.onebrand.prod}&claimnum=${claimNumber}`;
      }else{
        return `${globalConfig.PL.cfb.legacy.prod}&claimnum=${claimNumber}`;
      }
    }else{
      if(isOneBrand()){
        return `${globalConfig.PL.cfb.onebrand.nonProd}&claimnum=${claimNumber}`;
      }else{
        return `${globalConfig.PL.cfb.legacy.nonProd}&claimnum=${claimNumber}`;
      }
    }
  } catch(error){
    return '';
  }
}

export const getPLMMRDomain = (isAgent: boolean): string => {
  try {
    if (isOneBrand()) {
      if (isPLProd()) {
        return isAgent
          ? globalConfig.PL.mmr.onebrand.prod.agent
          : globalConfig.PL.mmr.onebrand.prod.employee;
      } else {
        return isAgent
          ? globalConfig.PL.mmr.onebrand.nonProd.agent
          : globalConfig.PL.mmr.onebrand.nonProd.employee;
      }
    } else {
      if (isPLProd()) {
        return isAgent
          ? globalConfig.PL.mmr.legacy.prod.agent
          : globalConfig.PL.mmr.legacy.prod.employee;
      } else {
        return isAgent
          ? globalConfig.PL.mmr.legacy.nonProd.agent
          : globalConfig.PL.mmr.legacy.nonProd.employee;
      }
    }
  } catch (error) {
    return '';
  }
};

export const getPLClaimsLink = (
  isAgent: boolean, 
  claimNumber: string, 
  customerId?: string
): string => {
  try {
    const domain = getPLMMRDomain(isAgent);
    if (!domain) return '';
    
    return isAgent
      ? `${domain}/claims?claimNumber=${claimNumber}${
          customerId ? '&customerId=' + customerId : ''
        }`
      : `${domain}/claims?activeRole=SAFECO_AGENCY_SERVICE${
          customerId ? '&customerId=' + customerId : ''
        }&claimNumber=${claimNumber}`;
  } catch (error) {
    return '';
  }
};

export const getPLMMRLink = (isAgent: boolean, policyNumber: string): string => {
  try {
    const domain = getPLMMRDomain(isAgent);
    if (!domain) return '';
    
    return isAgent
      ? `${domain}/?policyNumber=${policyNumber}`
      : `${domain}/?policyNumber=${policyNumber}&activeRole=SAFECO_AGENCY_SERVICE`;
  } catch (error) {
    return '';
  }
};


export const getISILink = (): string => {
  try{
    if (isPLProd()){
      if(isOneBrand()){
        return globalConfig.PL.isi.onebrand.prod;
      } else{
        return globalConfig.PL.isi.legacy.prod;
      }
    } 
    else if (isBLProd()) return globalConfig.BL.isi.prod;
    else if (isPL()){
      if(isOneBrand()){
        return globalConfig.PL.isi.onebrand.nonProd;
      } else
      return globalConfig.PL.isi.legacy.nonProd;
    }
    else{
        return globalConfig.BL.isi.nonProd;
    }
  } catch(error){
    return '';
  }
};

export const getPLPSTLink = (): string => {
  try{
    if (isPLProd()) {
      if(isOneBrand()){
        return globalConfig.PL.pstLink.onebrand.prod;
      }else{
        return globalConfig.PL.pstLink.legacy.prod;
      }
    } else {
      if(isOneBrand()){
        return globalConfig.PL.pstLink.onebrand.nonProd;
      } else {
        return globalConfig.PL.pstLink.legacy.nonProd;
      }
    }
  } catch(error){
    return '';
  }
};

export const getClientList = (): string => {
  try{
    if (isPLProd()) {
      if(isOneBrand()){
        return globalConfig.PL.clientList.onebrand.prod;
      } else{
        return globalConfig.PL.clientList.legacy.prod;
      }
    } else {
      if(isOneBrand()){
        return globalConfig.PL.clientList.onebrand.nonProd;
      } else {
        return globalConfig.PL.clientList.legacy.nonProd;
      }
    }
  } catch {
    return '';
  }
};

export const getClientListDeepLink = (): string | null => {
  if (isPLProd()) {
    return globalConfig.PL.clientListDeepLink.prod;
  } else if (isPL()) {
    return globalConfig.PL.clientListDeepLink.nonProd;
  }
  return null;
};
//add a unit test
//jest
export const getBillingPaymentServicesLink = (): string => {
  try{
    if (isPLProd()) {
      if(isOneBrand()){
        return globalConfig.PL.billingPaymentServicesLink.onebrand.prod;
      } else{
        return globalConfig.PL.billingPaymentServicesLink.legacy.prod;
      }
    } else {
      if(isOneBrand()){
        return globalConfig.PL.billingPaymentServicesLink.onebrand.nonProd;
      } else{
        return globalConfig.PL.billingPaymentServicesLink.legacy.nonProd;
      }
    }
  } catch(error){
    return '';
  }
};

export const getBLPolicyInquiryLink = (isAgent: boolean): string => {
  const userObject = isAgent ? globalConfig.BL.wasPortal.agent : globalConfig.BL.wasPortal.employee;
  const link = isProd() ? userObject.prod : userObject.nonProd;
  return link + '/portal/apodsearch.jsp?market=C';
};

export const getBLBillingInquiryLink = (isAgent: boolean, userId: string, statcode: string): string => {
  const userObject = isAgent ? globalConfig.BL.wasPortal.agent : globalConfig.BL.wasPortal.employee;
  const link = isProd() ? userObject.prod : userObject.nonProd;
  return link + '/portal/CommonCtrl?handler_name=BillingStartHandler&lramidkey=' + userId + '&agencyCode=' + statcode;
};

export const getBLClaimsInquiryLink = (isAgent: boolean, userId: string, statcode: string): string => {
  const userObject = isAgent ? globalConfig.BL.wasPortal.agent : globalConfig.BL.wasPortal.employee;
  const link = isProd() ? userObject.prod : userObject.nonProd;
  return (
    link +
    '/portal/CommonCtrl?handler_name=ClaimStartHandler&lramidkey=' +
    userId +
    '&agencyNumber=' +
    statcode +
    '&newSearch=Y'
  );
};

export const getQualitricsId = () => {
  const id = isProd() ? 'ZN_agyJhFxNlbwPtuB' : 'ZN_agAbkmeQHXzF3q5';
  return id;
};

export const getPingLogoutLink = () =>
  isProd() ? globalConfig.BL.pingLogoutLink.prod : globalConfig.BL.pingLogoutLink.nonProd;
export const getWasLogoutLink = () =>
  isProd() ? globalConfig.BL.wasLogoutLink.prod : globalConfig.BL.wasLogoutLink.nonProd;

export const getOmniChatUrl = (): string => {
  try {
    return isProd() ? globalConfig.PL.ChatUI.prod : globalConfig.PL.ChatUI.nonProd;
  } catch (err: any) {
    console.error(`Error in GlobalConfiguration.getOmniChatUrl(): ${err.message}`);
  }
  return '';
};

export const getMiddleMarketUrl = (): string => {
  return isProd() ? globalConfig.MiddleMarketUrl.prod : globalConfig.MiddleMarketUrl.nonProd;
}

export const getSuretyUrl = (): string => {
  return isProd() ? globalConfig.SuretyUrl.prod : globalConfig.SuretyUrl.nonProd;
}

export const getStateAutoUrl = (): string => {
  return isProd() ? globalConfig.StateAutoUrl.prod : globalConfig.StateAutoUrl.nonProd;
}

export const getCustomerUISearchResultsUrl = () =>
  isOneBrand() ? `${isProd() ? myWorkConfig.customerUI.onebrand.prod : myWorkConfig.customerUI.onebrand.nonProd}${
    myWorkConfig.customerUI.searchResultsPath
  }` :  `${isProd() ? myWorkConfig.customerUI.legacy.prod : myWorkConfig.customerUI.legacy.nonProd}${
    myWorkConfig.customerUI.searchResultsPath
  }`;
export const getCustomerUISummaryUrl = () =>
  isOneBrand() ? `${isProd() ? myWorkConfig.customerUI.onebrand.prod : myWorkConfig.customerUI.onebrand.nonProd}${myWorkConfig.customerUI.sumarryPath}` : `${isProd() ? myWorkConfig.customerUI.legacy.prod : myWorkConfig.customerUI.legacy.nonProd}${myWorkConfig.customerUI.sumarryPath}`;


export const getClaimsUIUrl = () =>
  `${isProd() ? myWorkConfig.claimsUI.prod : myWorkConfig.claimsUI.nonProd}${myWorkConfig.claimsUI.summaryPath}?123`; //claims ui chokes without a query string

export const getSettingsUIUrl = () => isOneBrand()
  ? `${isProd() ? myWorkConfig?.settings?.onebrand?.prod : myWorkConfig?.settings?.onebrand?.nonProd}`
  : `${isProd() ? myWorkConfig?.settings?.legacy?.prod : myWorkConfig?.settings?.legacy?.nonProd}`;